
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".793","y":".5","width":"54","height":"43","rx":"4.5","fill":"#fff","stroke":"#CED4DA"}}),_c('circle',{attrs:{"cx":"27.793","cy":"22","r":"10","fill":"#000"}}),_c('path',{attrs:{"stroke":"#fff","stroke-width":"2","d":"M16.793 22h12M28.008 23V11M27.75 21.293l8 8"}})])
          )
        }
      }
    